import { a as SET_PAGE_NAME_VAR } from './index2.js';

/**
 * **Travelline dataLayer**
 *
 * @exports bs_51
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const dataLayerPages = {
        payment: 'User Register Page',
    };
    /**
     * @memberOf module:bs_0
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
    engine.boot = function boot() {
        // eslint-disable-next-line no-new
        new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event === 'thnBookingEngineStepChanged' && message.thn.step) {
                window[SET_PAGE_NAME_VAR] = dataLayerPages[message.thn.step];
                thn.pageCheck();
            }
        }, true);
    };
    /**
     * @memberOf module:bs_51
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // https://www.pegasusreefhotel.com/booking?date=2025-01-22&nights=1&adults=2&children-age=3;1&access-code=&hotel_id=506140
        // https://angelbeachclub.com/booking/?date=2025-01-22&nights=1&adults=1&children-age=1;2&access-code=&hotel_id=505472
        const url = new URL(ctx.baseUrl);
        const validUrl = url.pathname.match(/booking/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        url.searchParams.set('date', '[date_begin]');
        url.searchParams.set('nights', '[nights]');
        url.searchParams.set('adults', '[adults]');
        url.searchParams.set('children-age', ctx.data.roomsDispo?.[0]?.childrenAges?.join(';') || '');
        // Export into ctx.newUrl
        ctx.newUrl = url.toString();
        ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace('/', '');
        return ctx;
    };
    return engine;
}

export { factory };
